import request from '@/utils/request'
import type {
  BannerDTO,
  InfoCategoryDTO,
  InfoCategoryListQuery,
  MediatorTypeDTO,
  OrgTypeDTO,
  CaseTypeDTO,
  CaseTypePayload,
  PaginatedResponse,
  SystemConfigDTO,
  SystemConfigBatch,
  BannerPayload,
  InfoCategoryPayload,
  MediatorTypePayload,
  OrgTypePayload
} from '@/types/api'

// System Config
export function getSystemConfig(): Promise<SystemConfigDTO> {
  return request({ url: '/system/config', method: 'get' })
}

export function updateSystemConfigBatch(
  data: SystemConfigBatch
): Promise<SystemConfigDTO> {
  return request({ url: '/system/config-batch', method: 'post', data })
}

// Banners
export function uploadAdminImage(data: FormData): Promise<{ url: string; filename: string }> {
  return request({
    url: '/system/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getBanners(): Promise<BannerDTO[]> {
  return request({ url: '/system/banners', method: 'get' })
}

export function createBanner(data: BannerPayload): Promise<BannerDTO> {
  return request({ url: '/system/banners', method: 'post', data })
}

export function updateBanner(
  id: number,
  data: BannerPayload
): Promise<BannerDTO> {
  return request({ url: `/system/banners/${id}`, method: 'put', data })
}

export function deleteBanner(id: number): Promise<void> {
  return request({ url: `/system/banners/${id}`, method: 'delete' })
}

// Info Categories
export function getInfoCategories(
  params: InfoCategoryListQuery = {}
): Promise<PaginatedResponse<InfoCategoryDTO>> {
  return request({ url: '/info-categories', method: 'get', params })
}

export function createInfoCategory(
  data: InfoCategoryPayload
): Promise<InfoCategoryDTO> {
  return request({ url: '/info-categories', method: 'post', data })
}

export function updateInfoCategory(
  id: number,
  data: InfoCategoryPayload
): Promise<InfoCategoryDTO> {
  return request({ url: `/info-categories/${id}`, method: 'put', data })
}

export function deleteInfoCategory(id: number): Promise<void> {
  return request({ url: `/info-categories/${id}`, method: 'delete' })
}

// Mediator Types
export function getMediatorTypes(): Promise<MediatorTypeDTO[]> {
  return request({ url: '/mediator-types', method: 'get' })
}

export function createMediatorType(
  data: MediatorTypePayload
): Promise<MediatorTypeDTO> {
  return request({ url: '/mediator-types', method: 'post', data })
}

export function updateMediatorType(
  id: number,
  data: MediatorTypePayload
): Promise<MediatorTypeDTO> {
  return request({ url: `/mediator-types/${id}`, method: 'put', data })
}

export function deleteMediatorType(id: number): Promise<void> {
  return request({ url: `/mediator-types/${id}`, method: 'delete' })
}

// Org Types
export function getOrgTypes(): Promise<OrgTypeDTO[]> {
  return request({ url: '/org-types', method: 'get' })
}

export function createOrgType(data: OrgTypePayload): Promise<OrgTypeDTO> {
  return request({ url: '/org-types', method: 'post', data })
}

export function updateOrgType(
  id: number,
  data: OrgTypePayload
): Promise<OrgTypeDTO> {
  return request({ url: `/org-types/${id}`, method: 'put', data })
}

export function deleteOrgType(id: number): Promise<void> {
  return request({ url: `/org-types/${id}`, method: 'delete' })
}

// Case Types (2026-06-24 新增)
export function getCaseTypes(): Promise<CaseTypeDTO[]> {
  return request({ url: '/case-types', method: 'get' })
}

export function createCaseType(data: CaseTypePayload): Promise<CaseTypeDTO> {
  return request({ url: '/case-types', method: 'post', data })
}

export function updateCaseType(
  id: number,
  data: CaseTypePayload
): Promise<CaseTypeDTO> {
  return request({ url: `/case-types/${id}`, method: 'put', data })
}

export function deleteCaseType(id: number): Promise<void> {
  return request({ url: `/case-types/${id}`, method: 'delete' })
}

export function getOrgTypesForCase(caseTypeId: number): Promise<Array<{id: number; name: string; status: number}>> {
  return request({ url: `/case-types/${caseTypeId}/org-types`, method: 'get' })
}
